export default __webpack_public_path__ + "static/media/Momentum_Robbi_Camera.926b2cd7.png";